/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const union_user_income_info = createAsyncThunk(
  'Saada/saadaAnchorGuideCenter/union_user_income_info',
  async (p: any, store: any) => {
    // return {
    //   income: '2123',
    //   union_id: 2345,
    //   union_leader_id: 11212,
    //   verified: false,
    // }
    const resp = await http.post(
      '/live/hiya_socialize/union_user_income_info',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const get_user_active_stats = createAsyncThunk(
  'Saada/saadaAnchorGuideCenter/get_user_active_stats',
  async (p: {time_type: 1 | 2} = {time_type: 1}, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/get_user_active_stats',
      {
        ...p,
      },
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)

const initialState: {
  home: any
  info: Partial<{
    text_stat: {
      online_time: number // 在线时长（单位：秒/分钟，需结合业务确认）
      message_cnt: number // 消息发送总数
      reply_rate_within_2_min: number // 2分钟内回复率（百分比值，如 30 表示 30%）
    }
    voice_call_stat: {
      call_duration: number // 语音通话总时长（单位：分钟/秒）
      call_count: number // 语音通话次数
      avg_call_duration: number // 语音平均通话时长（单位：分钟/秒）
      answer_rate: number // 语音通话接听率（百分比值）
    }
    video_call_stat: {
      call_duration: number // 视频通话总时长（单位：分钟/秒）
      call_count: number // 视频通话次数
      avg_call_duration: number // 视频平均通话时长（单位：分钟/秒）
      answer_rate: number // 视频通话接听率（百分比值）
    }
    room_stat: {
      mic_duration: number // 上麦总时长（单位：分钟/秒）
      enter_room_with_follow_cnt: number // 关注后进入房间的用户数
    }
  }>
} = {
  home: {},
  info: {},
}

export function useSaadaAnchorGuideCenter() {
  return useSelector((store) => store.SaadaAnchorGuideCenter)
}

export const SaadaAnchorGuideCenterSlice = createSlice({
  name: 'SaadaAnchorGuideCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(union_user_income_info.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload)
    })
    builder.addCase(get_user_active_stats.fulfilled, (state, action) => {
      Object.assign(state.info, action.payload)
    })
  },
})

export default SaadaAnchorGuideCenterSlice.reducer
export const SaadaAnchorGuideCenterActions = SaadaAnchorGuideCenterSlice.actions
